module.exports = __webpack_public_path__ + "img/other_light.e38aff9b.png";